import { render, staticRenderFns } from "./404.vue?vue&type=template&id=793d1ea6"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=793d1ea6&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793d1ea6')) {
      api.createRecord('793d1ea6', component.options)
    } else {
      api.reload('793d1ea6', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=793d1ea6", function () {
      api.rerender('793d1ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/404.vue"
export default component.exports